export default __webpack_public_path__ + "static/media/node-white.0b17d83e.svg";